import { createContext, useState, useMemo, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useGlobalContext } from "./../globalContext";
import useStepFourValues from "./useStepFourValues";
import useStepThreeValues from "./useStepThreeValues";
import { getPersistedIdentificationStatus } from "../../utils/constants/piFormSession";

export const StepsContext = createContext(null);

export function StepsContextProvider({ children }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const {
    globalData: { status },
  } = useGlobalContext();
  const effectiveStatus = status || getPersistedIdentificationStatus();
  const { stepThreeValues, setStepThreeValues } = useStepThreeValues();
  const { stepFourValues, setStepFourValues } = useStepFourValues();

  const [redirectUrl, setRedirectUrl] = useState(null);

  const [activeStep, setActiveStep] = useState({
    id: 1,
    title: t("identificationStep2"),
    route: `/Identomat/${i18n.language}`,
  });

  const steps = useMemo(
    () => [
      {
        id: 1,
        title: t("identificationStep2"),
        route: `/Identomat/${i18n.language}`,
      },
      {
        id: 2,
        title: t("identityInformation4"),
        disabled: effectiveStatus !== "Approved",
        route: `/step/3`,
      },
      {
        id: 3,
        title: t("identityInformation5"),
        disabled: effectiveStatus !== "Approved",
        route: `/step/4`,
      },
    ],
    [effectiveStatus, i18n.language, t]
  );

  const nextStep = () => {
    steps.forEach((step) => {
      if (step.id === activeStep.id + 1) {
        history.push(step.route);
      }
    });
  };

  const prevStep = () => {
    if (activeStep.id - 1 !== 2) {
      steps.forEach((step) => {
        if (step.id === activeStep.id - 1) {
          history.push(step.route);
        }
      });
    }
  };

  return (
    <StepsContext.Provider
      value={{
        activeStep,
        nextStep,
        prevStep,
        redirectUrl,
        setRedirectUrl,
        steps,
        stepThreeValues,
        setStepThreeValues,
        stepFourValues,
        setStepFourValues,
        setActiveStep,
      }}
    >
      {children}
    </StepsContext.Provider>
  );
}

export function useStepsContext() {
  const value = useContext(StepsContext);
  if (!value) {
    throw new Error("PI Steps context Provider is not defined");
  }
  return value;
}
